import { Head } from '@inertiajs/react'
import AppShowcaseCarousel from '@/components/public/AppShowcaseCarousel'
import BewaveFooter from '@/components/public/BewaveFooter'
import HowItWorks from '@/components/public/HowItWorks'
import PricingPlans from '@/components/public/PricingPlans'
import PublicHeader from '@/components/public/PublicHeader'
import SurfShorts from '@/components/public/SurfShorts'
import type { CityOption, ShowcaseSchool } from '@/types/publicSchool'

interface HomeProps {
  cities: CityOption[]
  /** Vitrine "Quem usa BeWave" — vem cortada pelo teto do HomeController. */
  schools: ShowcaseSchool[]
  /** Total de escolas na vitrine, para a seção dizer quantas ficaram de fora. */
  schools_total: number
  /** Origem absoluta do Explore — ele mora em outro host (ver ExploreHost). */
  explore_origin: string
}

/**
 * Landing da plataforma.
 *
 * Header e rodapé são os mesmos de /explore e /schools/:slug — a área pública
 * inteira usa a mesma casca. Aqui, porém, ela não pitcha o Explore como
 * produto à parte: `hideExploreNav`/`hideExploreLinks` tiram a navegação, a
 * porta de entrada do menu de conta e o convite "Criar sua página", deixando
 * só um link "BeWave Explore" no rodapé (ajuda a indexação do diretório sem
 * competir por espaço com o pitch da gestão, que é o produto desta página).
 *
 * A ordem das seções é o argumento: o que o sistema faz, como ele aparece para o
 * aluno e para o dono, a prova em vídeo de que a gente conhece as escolas que
 * lista, e só então quanto custa.
 *
 * A marca não linka aqui: você já está na home.
 */
// `schools` e `schools_total` continuam chegando do controller para a vitrine
// "Quem usa BeWave" (`SchoolsUsingBewave`), que está fora do ar enquanto a landing
// é remontada.
export default function Home({ cities, explore_origin }: HomeProps) {
  return (
    <div className="flex min-h-screen flex-col bg-bewave-surface text-gray-900 antialiased">
      <Head title="BeWave — gestão para escolas de surf" />

      <PublicHeader cities={cities} hideExploreNav />

      <main className="flex-1">
        <HowItWorks />
        <AppShowcaseCarousel />
        <PricingPlans />
        <SurfShorts />
      </main>

      <BewaveFooter hideExploreLinks exploreOrigin={explore_origin} />
    </div>
  )
}
